import React from 'react';
import { IconProps } from './typing';

interface DisableIconProps extends IconProps {
  readonly fillColor?: string;
}
const Disabled = ({ iconSize, fillColor }: DisableIconProps) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox="0 0 64 64"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group Disabled</title>
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      opacity="0.8"
    >
      <g
        transform="translate(-119.000000, -330.000000)"
      >
        <g transform="translate(119.000000, 330.000000)">
          <circle
            stroke="#757575"
            stroke-width="4"
            fill={fillColor || "#999999"}
            opacity="0.9"
            cx="32"
            cy="32"
            r="30"
          ></circle>
          <g transform="translate(15.000000, 15.000000)">
            <circle
              stroke="#D8D8D8"
              stroke-width="4"
              fill={fillColor || "#999999"}
              opacity="0.7"
              cx="17"
              cy="17"
              r="15"
            ></circle>
            <line
              x1="27.4992642"
              y1="6.78463855"
              x2="5.42385542"
              y2="28.8600474"
              stroke="#C7C7C8"
              stroke-width="3"
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Disabled;
